"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordToMap = exports.hasType = exports.isFieldDef = void 0;
function isFieldDef(obj) {
    return typeof obj === "object" && obj !== null && "key" in obj && "def" in obj;
}
exports.isFieldDef = isFieldDef;
function hasType(obj) {
    return typeof obj === "object" && obj !== null && "type" in obj;
}
exports.hasType = hasType;
function recordToMap(records) {
    return new Map(Object.entries(records).reduce((acc, elem) => {
        const [key, value] = elem;
        if (!value)
            return acc;
        return [...acc, [key, value]];
    }, []));
}
exports.recordToMap = recordToMap;
